
import calendarAPI from '@/api/calendarAPI'

function parseEventData(courses, labels, event){
  let label = labels.find(label => label.value === event.type)

  let course = courses[event.data.course]

  let title = `${label.text}`

  if(event.type === 'quiz'){
    let date = new Date(event.date)
    let time = date.getHours()+':'+date.getMinutes()
    title += ` يبدا الساعة ${time}`
  } else if(event.type === 'assignment') {
    title = 'آخر موعد لتسليم ' + title
  } else {
    title = event.data.title
  }

  title += ` (${course.name} - ${event.data.group})`

  return { id: event.id, title: title, startDate: event.date, classes: `event-${label.color}`, label: label.value }
}

export default {
  addEvent({ commit, state, rootState }, event) {
    return new Promise((resolve, reject) => {
      calendarAPI.create(event)
        .then(response => {
          event.groups.forEach(group => {
            commit('ADD_EVENT', parseEventData(rootState['courses']['all'], state.eventLabels,{
              data: { course: event.course_id, group: group, title: event.title },
              date: event.date,
              id: response.data.id,
              type: 'event'
            }))
          })
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchEvents({ commit, state, rootState }) {
    return new Promise((resolve, reject) => {
      let events = []
      let courses = rootState['courses']['all']
      let labels = state.eventLabels
      calendarAPI.getAll().then( ({data}) => {
        data.calendar.forEach(event => {
          event.data = JSON.parse(event.data)
          events.push(parseEventData(courses, labels, event))
        })
        commit('SET_EVENTS', events)
        resolve(data.calendar)
      }).catch(error => reject(error))
    })
  },
  removeEvent({ commit }, eventId) {
    commit('REMOVE_EVENT', eventId)
    return new Promise((resolve, reject) => {
      calendarAPI.delete(eventId)
        .then((response) => {resolve(response)})
        .catch((error) => { reject(error) })
    })
  },
}
